export const externalLinks = {
  instagram: "https://www.instagram.com/restituir.st/",
  whatsapp: "https://api.whatsapp.com/send/?phone=27998294321&text&type=phone_number&app_absent=0",
  tenhoInteresseRepresentanteWhatsapp:
    "https://wa.me/5527998294321?text=Olá%2C+tenho+interesse+em+ser+representante+da+RT+Soluções+Tributárias",
};
